import { useEffect, useState, useCallback } from 'react'
import { getDataobtener } from '../../api/common'

/**
 * Custom hook para gestionar lógica de estado en Otselect.js (legacy)
 * Centraliza fetch de datos, estado, y filtrado de equipos según task
 * 
 * @param {Object} params
 * @param {string} params.id - ID de la orden de trabajo
 * @param {URLSearchParams} params.searchParams - Parámetros de URL (task)
 * @returns {Object} Estado y funciones para gestionar OT
 */
export default function useOtLogicLegacy({ id, searchParams }) {
  const [ots, setOt] = useState({})
  const [equiposOtIni, setEquiposOtIni] = useState([])
  const [sedes, setSedes] = useState([])
  const [modalcharge, SetModalcharge] = useState(false)
  const [refreshFlag, setRefreshFlag] = useState(0)
  const [error, setError] = useState(null)
  
  const task = searchParams?.get('task')
  
  /**
   * Función para forzar refresh de datos
   */
  const toggleRefresh = useCallback(() => {
    setRefreshFlag(f => f + 1)
  }, [])
  
  /**
   * Efecto para cargar datos de la OT
   */
  useEffect(() => {
    let mounted = true
    const controller = new AbortController()
    
    async function getOt() {
      if (!id) {
        setError('No se proporcionó ID de OT')
        return
      }
      
      SetModalcharge(true)
      setError(null)
      
      try {
        const otDB = await getDataobtener(id, { signal: controller.signal })
        
        if (!mounted) return
        
        const data = otDB?.data?.data
        
        if (!data) {
          throw new Error('No se encontraron datos de la OT')
        }
        
        setOt(data)
        
        // Filtrar equipos según task
        // revisar: Todos los equipos
        // finalizar: Solo los que NO tienen fechaCalibracion
        const equiposDisponibles = task === 'revisar' 
          ? data.equipos || []
          : (data.equipos || []).filter(eq => !eq.fechaCalibracion)
        
        setEquiposOtIni(equiposDisponibles)
        
        console.log('✅ OT cargada:', data);
        // Extraer sedes únicas de los equipos
        const sedesUnicas = [...new Set(
          (data.equipos || [])
            .map(eq => eq.equipo?.sedeClient)
            .filter(Boolean)
        )]
        
        setSedes(sedesUnicas)
        
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('Fetch cancelado')
          return
        }
        
        console.error('Error cargando OT:', error)
        if (mounted) {
          setError(error.message || 'Error al cargar la orden de trabajo')
        }
      } finally {
        if (mounted) {
          SetModalcharge(false)
        }
      }
    }
    
    getOt()
    
    // Cleanup
    return () => {
      mounted = false
      controller.abort()
    }
  }, [refreshFlag, id, task])
  
  return {
    ots,
    setOt,
    equiposOtIni,
    setEquiposOtIni,
    sedes,
    setSedes,
    modalcharge,
    SetModalcharge,
    toggleRefresh,
    error
  }
}
